
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[resort]/skirentals",
      function () {
        return require("private-next-pages/[region]/[resort]/skirentals.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[resort]/skirentals"])
      });
    }
  